<template lang="pug">
  v-dialog(
    width="500"
    :elevation="0"
    v-model="dialog"
    flat
    content-class="elevation-0"
  )
    template(v-slot:activator="{ on }")
      v-text-field(
        label="Дата мероприятия"
        outlined
        hide-details
        background-color="white"
        dense
        v-model="model"
        @focus="dialog = true"
      )

    .d-flex.justify-end
      v-btn.mb-3.ml-auto( text dark @click="dialog = false" ) Закрыть
    v-date-picker(v-model="model" full-width)
</template>

<script>
/**
 * @displayName Publish date picker
 */
export default {
  name: 'publish-date-picker',
  props: {
    /**
     * @model Date string in ISO format 'year-month-date'
     */
    value: {
      type: String,
      default: new Date().toISOString().substr(0, 10)
    }
  },
  data() {
    return {
      dialog: false
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },

      set(val) {
        this.$emit('input', val)
        this.dialog = false
      }
    }
  }
}
</script>
